"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IHttpApiFetchConfig.js.map